import React, { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, CircularProgress, Link, Typography } from '@mui/material';
import { verifyEmail } from '../../services/authService';
import { extractErrorMessage } from '../../utils/errors';
import { AuthLayout, FormError, authLinkSx } from './AuthLayout';
import useUrlToken from './useUrlToken';

export default function VerifyEmailPage() {
  const token = useUrlToken();
  const [status, setStatus] = useState(token ? 'loading' : 'error');
  const [error, setError] = useState(token ? '' : 'Ссылка недействительна или устарела');
  // Токен одноразовый: повторный вызов (StrictMode) показал бы ошибку после успеха
  const startedRef = useRef(false);

  useEffect(() => {
    if (!token || startedRef.current) return;
    startedRef.current = true;
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setError(extractErrorMessage(err));
        setStatus('error');
      });
  }, [token]);

  return (
    <AuthLayout title="Подтверждение email" onSubmit={(event) => event.preventDefault()}>
      {status === 'loading' && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }} aria-busy="true">
          <CircularProgress size={28} />
        </Box>
      )}
      {status === 'success' && (
        <Typography role="status" sx={{ fontSize: '15px', color: '#fff' }}>
          Email подтверждён
        </Typography>
      )}
      {status === 'error' && <FormError>{error}</FormError>}
      <Box sx={{ textAlign: 'center', fontSize: '14px' }}>
        <Link component={RouterLink} to="/" sx={authLinkSx}>
          {status === 'success' ? 'Перейти в приложение' : 'Вернуться в приложение'}
        </Link>
      </Box>
    </AuthLayout>
  );
}
